// Utility to export SVG to PNG
export function exportSvgToPng(svg: SVGSVGElement) {
  const scaleFactor = 2.0; // Export at 2x resolution

  // Get the natural dimensions of the SVG content
  const bBox = svg.getBBox();
  const naturalWidth = Math.max(1, Math.ceil(bBox.width)); // Ensure at least 1px
  const naturalHeight = Math.max(1, Math.ceil(bBox.height)); // Ensure at least 1px

  const exportWidth = naturalWidth * scaleFactor;
  const exportHeight = naturalHeight * scaleFactor;

  const clonedSvg = svg.cloneNode(true) as SVGSVGElement;
  clonedSvg.removeAttribute('width');
  clonedSvg.removeAttribute('height');
  clonedSvg.setAttribute('width', exportWidth.toString());
  clonedSvg.setAttribute('height', exportHeight.toString());

  // It's important that the viewBox is correctly set on the original SVG
  // or copied here if necessary, so the scaling works as expected.
  // Mermaid usually sets a viewBox like "0 0 width height".
  // If viewBox is e.g. "x y width height", ensure it's preserved or handled.

  const svgData = new XMLSerializer().serializeToString(clonedSvg);
  const img = new window.Image();
  img.src =
    'data:image/svg+xml;base64,' +
    window.btoa(unescape(encodeURIComponent(svgData)));
  img.onload = function () {
    const canvas = document.createElement('canvas');
    canvas.width = exportWidth;
    canvas.height = exportHeight;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = '#fff'; // Set background to white
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        if (blob) {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'diagram.png';
          a.click();
          URL.revokeObjectURL(url);
        }
      }, 'image/png');
    }
  };
}
